export default class {
	idDocumentoAta
	tipoRegistroDocumento
	situacao

	constructor(documento) {
		this.idDocumentoAta = documento.id
		this.tipoRegistroDocumento = documento.tipoRegistroDocumento
		this.situacao = documento.situacao
	}
}
